export default [
  {
    description:
      'Ainihanifa.com bercerita tentang minimalis jurnal terkait kehidupan pribadi, dan traveling oleh @ainihanifa',
    title: 'Sekilas Mengenai Ainihanifa',
    media: ['https://i.imgur.com/1U5htEQ.mp4']
  }
]
